import React, { useEffect, useState } from "react";
import "./pageStyles.scss";
import {
  Button,
  Grid,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import Search from "@material-ui/icons/Search";
import DMModal from "../components/common/controls/DMModal";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import AntSwitch from "../components/common/controls/AntSwitch";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import DMModelSelect from "../components/common/DMModelSelect";
import { sortViewService } from "../services/ViewsService";
import * as miscAction from "../actions/miscAction";
import * as viewsAction from "../actions/viewsAction";
import * as modelAction from "../actions/modelAction";
import { connect } from "react-redux";
import Loading from "../components/Loading/Loading";
import WarningPopup from "../components/common/controls/warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../constants/constants";


var CONTROLS_DATA = require("./ControlsData.json");
var VIEWS_CONTROLS = CONTROLS_DATA.SCREENS.VIEWS;

const Views = ({
  viewsState,
  miscState,
  getViews,
  createNewView,
  deleteView,
  setSnackBar,
  UpdateView,
  intl,
  fullLangCode
}) => {
  // const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState();
  const [showNewView, setShowNewView] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedView, setSelectedView] = useState();
  const [isDisabled, setIsDisabled] = useState(true);

  const [newView, setNewView] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);

  const onNewViewClick = () => setShowNewView(true);

  const [views, setViews] = useState([]);

  const onDelete = (viewName) => {
    setShowDelete(true);
    setSelectedView(views.filter((m) => m.viewName === viewName)[0]);
  };

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  const isViewPresentCreate = (viewName, data) => {
    let isPresent = false;
    for (let view of data) {
      if (viewName.toLowerCase() === view.viewName.toLowerCase()) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const isViewPresent = (viewName, data, selectedView) => {
    let isPresent = false;
    if (viewName === selectedView?.viewName) {
      return { isSame: true, isPresent };
    }
    for (let view of data) {
      if (viewName.toLowerCase() === view.viewName.toLowerCase()) {
        isPresent = true;
        break;
      }
    }
    return { isSame: false, isPresent };
  };

  const onUpdateViewName = async (view, value) => {
    const { isSame, isPresent } = isViewPresent(
      value,
      viewsState.views.data,
      view
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(true, "error", injectIntlTranslation(intl, "viewAlreadyExistError" , constants.viewAlreadyExistError));
      setGridData([]);
      setViews([...views]);
    } else {
      try {
        const payload = {
          modelId: view.modelId,
          viewId: view.viewId,
          viewName: value,
          sort: view.sort,
          isHidden: !view.isHidden,
        };
        await UpdateView(payload);

        if (!viewsState.updateView.hasError) {
          await getViews(miscState.selectedModel);
          setSnackBar(true, "success", `${injectIntlTranslation(intl, "updateViewSucess" , constants.updateViewSucess)} ${value}`);
        }
      } catch (error) {
        setSnackBar(true, "error", `${injectIntlTranslation(intl, "updateViewError" , constants.updateViewError)} ${value}`);
      }
    }
  };

  const handleCreateView = async () => {
    setIsDisabled(true);
    setShowNewView(false);
    if (isViewPresentCreate(newView.viewName, viewsState.views.data)) {
      setSnackBar(true, "error", injectIntlTranslation(intl, "viewAlreadyExistError" , constants.viewAlreadyExistError));
    } else {
      try {
        const payload = {
          modelId: miscState.selectedModel,
          viewName: newView?.viewName,
          sort: views.length + 1,
          isHidden: !newView?.isVisible,
        };
        await createNewView(payload);
        if (!viewsState.createNewView.hasError) {
          setShowNewView(false);
          await getViews(miscState.selectedModel);
          setViews(viewsState.views.data);
          setSnackBar(true, "success", `${injectIntlTranslation(intl, "createViewSuccess" , constants.createViewSuccess)} ${newView?.viewName}`);
          setIsDisabled(true);
        }
      } catch (error) {
        setShowNewView(false);
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(intl, "createViewError" , constants.createViewError)} ${newView?.viewName}`
        );
      }
    }
  };

  useEffect(() => {
    getViews(miscState?.selectedModel);
  }, [miscState?.selectedModel]);

  useEffect(() => {
    setLoading(viewsState.views.isLoading);
  }, [viewsState.views.isLoading]);

  useEffect(() => {
    const filterData =
      viewsState?.views?.data?.slice().sort((a, b) => a.sort - b.sort) || [];
    const updatedFields = filterData.map((obj) => {
      return { ...obj, isHidden: obj.isHidden ? false : true };
    });
    setViews(updatedFields);
  }, [viewsState.views.data]);

  useEffect(() => {
    if (viewsState.views.hasError) {
      setSnackBar(true, "error", injectIntlTranslation(intl, "retriveViewError" , constants.retriveViewError));
    }
  }, [viewsState.views.hasError]);

  /* Update status*/
  const onUpdateViewSwitch = async (value) => {
    try {
      const payload = {
        modelId: value.modelId,
        viewId: value.viewId,
        viewName: value.viewName,
        sort: value.sort,
        isHidden: value.isHidden,
      };
      await UpdateView(payload);
      if (!viewsState.updateView.hasError) {
        await getViews(miscState.selectedModel);
        setSnackBar(true, "success", `${injectIntlTranslation(intl, "updateViewSucess" , constants.updateViewSucess)} ${value?.viewName}`);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(intl, "updateViewError" , constants.updateViewError)} ${value?.viewName}`
      );
    }
  };

  const onDrag = async (data) => {
    const filteredPayload = [];
    data.forEach((item, index) => {
      const paylod = {
        id: item.rowId,
        sort: index,
      };
      filteredPayload.push(paylod);
    });
    if (filteredPayload.length > 0) {
      await sortViewService(filteredPayload)
        .then((response) => {
          setSnackBar(true, "success", `${injectIntlTranslation(intl, "sortDataSuccess" , constants.sortDataSuccess)}`);
        })
        .catch((error) => {
          setSnackBar(true, "error", injectIntlTranslation(intl, "sortingError" , constants.sortingError));
        });
    }
  };

  useEffect(() => {
    const ctrlData = [];
    if (searchValue.length > 0) {
      setSelectedPage(1);
    }
    const filteredViews = views?.filter((e) =>
      e.viewName.toLowerCase().includes(searchValue)
    );
    filteredViews.forEach((view) => {
      ctrlData.push({
        rowId: view.viewId,
        highlight: view.isHidden ? "" : "highlight",
        viewId: view.viewId,
        rowKey: view.viewName,
        sort: view?.sort,
        rowValue: [
          {
            colType: "draggable-contained-label",
            colOptions: {
              width: "534px",
              value: view.viewName,
              tab: "views",
              view: view,
              onUpdate: onUpdateViewName,
              fullLangCode: fullLangCode
            },
          },
          {
            colType: "ant-switch",
            colOptions: {
              value: view.isHidden,
              onChange: () => {
                onUpdateViewSwitch(view);
              },
            },
          },
          {
            colType: "grid-actions",
            colOptions: [
              { name: "delete", action: () => onDelete(view.viewName) },
            ],
          },
        ],
      });
    });
    setGridData([...ctrlData.sort((a, b) => a.sort - b.sort)]);
    // setViews(views);
  }, [views, searchValue, sortBy, fullLangCode]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      minWidth: 222,
      "& .MuiSelect-root": {
        padding: "10px",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "73% 24% 3%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  const handleNewViewName = (e) => {
    setNewView({ ...newView, viewName: e.target.value });
  };

  const handleStatusNewView = (e) => {
    setNewView({ ...newView, isVisible: e.target.checked });
  };

  const deleteConfirm = async (selectedView) => {
    try {
      await deleteView({ viewId: selectedView?.viewId });
      if (!viewsState?.deleteView?.hasError) {
        setShowDelete(false);
        await getViews(miscState?.selectedModel);
        setViews(viewsState?.views?.data);
        setSnackBar(
          true,
          "success",
          `${selectedView.viewName} ${injectIntlTranslation(intl, "modelDeleteSuccess" , constants.modelDeleteSuccess)}.`
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(intl, "viewDeleteError" , constants.viewDeleteError)} ${selectedView.viewName}`
      );
    }
  };

  useEffect(() => {
    setIsDisabled(!(newView && newView?.viewName?.length > 0));
  }, [newView]);

  const onSelectedPage = (page) => { setSelectedPage(page); console.log("page changed to", page) }
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    setPageSize(gridData.length);
    setShowTable(false);
  }, [gridData]);

  useEffect(() => {
    if (!showTable) {
      // console.log(pageSize)
      setShowTable(true);
    }
  }, [showTable]);

  return (
    <div container className="page-container content-center views-page">
      <Grid container xs={12} md={9} className="page-content">
        <Grid container item xs={12} md={5} className="page-menu">
          <DMModelSelect />
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          className="page-menu"
          justify="flex-end"
        >
          <Grid item container xs={12} md={2} justify="center"></Grid>
          <Grid
            item
            container
            xs={12}
            md={7}
            justify="flex-end"
            className="search-wrapper"
          >
            <TextField
              id="search"
              placeholder={injectIntlTranslation(intl, "searchPlacholder" , constants.searchPlacholder)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleSearch(e.target.value)}
              autoComplete={"off"}
            />
          </Grid>
          <Grid item container xs={12} md={3} justify="flex-end">
            <CustomButton
              id="newView"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name={injectIntlTranslation(intl, "newViewBtnLabel" , constants.newViewBtnLabel)}
              onClick={onNewViewClick}
            />
          </Grid>
        </Grid>
        {gridData.length > 0 && showTable && (
          <DMGrid
            headers={VIEWS_CONTROLS.GRID_HEADERS}
            headerClassName={classes.gridHeaderColumns}
            data={gridData}
            draggable={true}
            tab="views"
            onDrag={onDrag}
            selectedPage={selectedPage}
            onPageSelection={onSelectedPage}
            pageSize={pageSize}
          />
        )}

        <WarningPopup
          open={showNewView}
          onClose={() => setShowNewView(false)}
          title={injectIntlTranslation(intl, "createNewView" , constants.createNewView)}
          description={
            <div style={{ textAlign: "center", width: "100%" }}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-basic"
                    label={injectIntlTranslation(intl, "viewNameFieldLabel" , constants.viewNameFieldLabel)}
                    variant="outlined"
                    onChange={handleNewViewName}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: "right",
                    paddingRight: "20px",
                    marginBottom: "50px",
                  }}
                >
                  <Typography
                    component="div"
                    style={{ display: "inline-block" }}
                  >
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <div>
                        <Typography style={{ fontSize: "20px" }}>
                          {injectIntlTranslation(intl, "isVisible" , constants.isVisible)}
                        </Typography>
                      </div>
                      <div>
                        <AntSwitch
                          checked={newView?.status}
                          onChange={handleStatusNewView}
                          name={injectIntlTranslation(intl, "statusLabel" , constants.statusLabel)}
                        />
                      </div>
                    </Grid>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  style={{ justifyContent: "right", gap: "20px" }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateView}
                    disabled={isDisabled}
                  >
                    {injectIntlTranslation(intl, "createBtnLabel" , constants.createBtnLabel)}
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowNewView(false);
                      setIsDisabled(true);
                    }}
                  >
                    {injectIntlTranslation(intl, "cancelBtnLabel" , constants.cancelBtnLabel)}
                  </Button>
                </Grid>
              </Grid>
            </div>
          }
          hideBtn={true}
        />

        <WarningPopup
          open={showDelete}
          onClose={() => setShowDelete(false)}
          title={injectIntlTranslation(intl, "modelDeleteTitle" , constants.modelDeleteTitle)}
          description={injectIntlTranslation(intl, "deleteViewWarningContent" , constants.deleteViewWarningContent)}
          saveButtonLabel={`${injectIntlTranslation(intl, "deleteBtnLabel" , constants.deleteBtnLabel)}`}
          onSave={() => {
            deleteConfirm(selectedView);
          }}
        />
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Loading />
    </div>
  );
};

const mapStateToProps = (state) => ({
  miscState: state.misc,
  viewsState: state.views,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getViews: async (requestPayload) =>
      dispatch(viewsAction.getViews(requestPayload)),
    createNewView: async (requestPayload) =>
      dispatch(viewsAction.createNewView(requestPayload)),
    UpdateView: async (requestPayload) =>
      dispatch(viewsAction.UpdateView(requestPayload)),
    deleteView: async (requestPayload) =>
      dispatch(viewsAction.deleteView(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
  };
};

export default  injectIntl(connect(mapStateToProps, mapDispatchToProps)(Views));
